var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame163050(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4246,
    cy: 19.4246,
    r: 19.4246,
    fill: "#3E9FF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5H14C11 27.5 9 26 9 22.5V15.5C9 12 11 10.5 14 10.5H24C27 10.5 29 12 29 15.5V22.5C29 26 27 27.5 24 27.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7698 14.7695L20.2228 19.0558C19.5025 19.6123 18.4973 19.6123 17.777 19.0558L12.23 14.7695",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame163050);
export default __webpack_public_path__ + "static/media/Frame 163050.65fb19a1affd9b22060db6300f3fefda.svg";
export { ForwardRef as ReactComponent };